import './index.css';
import { PublisherModalProvider } from '../components/publisher-modal';
import { Hero, Nav } from '../sections/hero';
import { HowItFits } from '../sections/product';
import { StageBuild, StageMeasure, StagePlay, StagePublish } from '../sections/pipeline';
import { Pricing } from '../sections/pricing';
import { FAQ, Testimonials } from '../sections/proof';
import { FinalCTA, Footer } from '../sections/footer';

const IndexPage = () => (
  <PublisherModalProvider>
    <Nav />
    <Hero />
    <HowItFits />
    <StageBuild />
    <StagePublish />
    <StagePlay />
    <StageMeasure />
    <Testimonials />
    <Pricing />
    <FAQ />
    <FinalCTA />
    <Footer />
  </PublisherModalProvider>
);

export default IndexPage;
